import { Check, Minus } from "lucide-react";
import { Checkbox as CheckboxPrimitive } from "radix-ui";
import { useId, type ReactNode } from "react";

import { cx } from "@/lib/cx";

import styles from "./Checkbox.module.css";

export interface CheckboxProps {
  label: ReactNode;
  checked: boolean | "indeterminate";
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
  /** Extra text after the label, e.g. a count. */
  hint?: string;
  /** Hide the label's text from sight but keep it for screen readers, when the row already shows the same words. */
  hideLabel?: boolean;
  className?: string | undefined;
}

export function Checkbox({
  label,
  checked,
  onCheckedChange,
  disabled = false,
  hint,
  hideLabel = false,
  className,
}: CheckboxProps) {
  const id = useId();
  return (
    <span className={cx(styles.row, className)}>
      <CheckboxPrimitive.Root
        id={id}
        checked={checked}
        disabled={disabled}
        onCheckedChange={(state) => {
          onCheckedChange(state === true);
        }}
        className={styles.box}
      >
        <CheckboxPrimitive.Indicator className={styles.indicator}>
          {checked === "indeterminate" ? (
            <Minus aria-hidden="true" />
          ) : (
            <Check aria-hidden="true" />
          )}
        </CheckboxPrimitive.Indicator>
      </CheckboxPrimitive.Root>
      <label htmlFor={id} className={cx(styles.label, hideLabel && styles.labelHidden)}>
        {label}
        {hint !== undefined && <span className={styles.hint}>{hint}</span>}
      </label>
    </span>
  );
}
